import './About.css'
import Avatar from '../../assets/icons/avatar.svg'
import Dot from '../../assets/icons/dot.svg'
import Doc from '../../assets/icons/doc.svg'
import { useEffect, useState } from 'react'

const About = () => {
  const [data, setData] = useState(null)

  useEffect(() => {
    fetch('https://api.github.com/users/ahmedsameh74')
    .then(res => res.json())
    .then(data => setData(data.avatar_url))
  })


  return (
    <div className="section" id="about">
      <div className="about-content">
        <div className="left">
          <div className="upper">
            <h1>
              <img src={Avatar} alt="avatar" />
              About Me
            </h1>
            <p>
              <img src={Dot} alt="dot" />
              I'm ahmed sameh a frontend developer
            </p>
            <p>
              <img src={Dot} alt="dot" />I have bachelor degree in computer and
              information systems
            </p>
            <p>
              <img src={Dot} alt="dot" />I have been learning and working in the
              frontend development for three years{" "}
            </p>
          </div>
          <div className="lower">
            <h1>
              <img src={Doc} alt="doc" />
              Experience
            </h1>

            <p>
              <img src={Dot} alt="dot" />
              {/* developing user interfaces */}
              HTML, CSS, JavaScript, React, Redux, Context API, Bootstrap, TypeScript, Next
            </p>
            <p>
              <img src={Dot} alt="dot" />
              {/* developing responsive websites */}
              Github, Git, NPM, YARN, Webpack, Netlify, Vercel
            </p>
            <p>
              <img src={Dot} alt="dot" />
              {/* developing web applications */}
              RESTful APIs, JSON, AJAX, Axios, Postman
            </p>
            <p>
              <img src={Dot} alt="dot" />
              {/* integerating with backend services */}
              Firebase, MongoDB, Mongoose, Express, Node.js
            </p>
          </div>
        </div>
        <div className="right">
          <img src={data} alt="avatar" />
        </div>
      </div>
    </div>
  );
}

export default About